import { useSignal } from '@funtech-int/rival-react';

import { useProfileManager } from './useProfileManager';

export const useHasSubscription = () => {
    const profileManager = useProfileManager();

    return useSignal(profileManager.hasSubscription);
};
